export function assignmentSummaryText(assignmentCount: number, hubCount: number): string {
  return `${assignmentCount} assignment${assignmentCount === 1 ? '' : 's'} across ${hubCount} hub${
    hubCount === 1 ? '' : 's'
  }`
}
